import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../components/UI';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Nav */}
      <nav className="bg-white border-b border-amber-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-5 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Logo size="sm" />
            <span className="font-serif font-bold text-green-900 text-lg">GolfBoard Scores</span>
          </Link>
          <Link to="/login" className="btn-primary text-sm">Sign In</Link>
        </div>
      </nav>

      <main className="flex-1 page-container py-12">
        <div className="max-w-xl mx-auto">
          <div className="text-center mb-8">
            <div className="text-5xl mb-4">✉️</div>
            <h1 className="font-serif font-bold text-3xl text-green-900 mb-2">Contact Us</h1>
            <p className="text-gray-500 text-sm">
              Questions, feedback, or just want to say hello? We'd love to hear from you.
            </p>
          </div>

          <div className="card p-8 space-y-6">
            {/* ── FILL IN YOUR CONTACT DETAILS BELOW ── */}

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 text-lg">📧</div>
              <div>
                <h3 className="font-semibold text-green-900 mb-1">Email</h3>
                {/* Replace the text below with your email address */}
                <p className="text-gray-500 text-sm italic">contact@golfboardscores.com</p>
              </div>
            </div>

            <div className="border-t border-amber-100" />

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0 text-lg">⚠️</div>
              <div>
                <h3 className="font-semibold text-green-900 mb-1">Report a Problem</h3>
                <p className="text-gray-500 text-sm">
                  Found a bug or something broken? If you're logged in, you can use the{' '}
                  <span className="font-medium text-green-800">"Report Issue"</span> link at the bottom of any page for the fastest response.
                </p>
              </div>
            </div>

            {/* ── END OF CONTACT DETAILS ── */}
          </div>

          <p className="text-center text-xs text-gray-400 mt-6">
            GolfBoard Scores is a small, independently-run project. We appreciate your patience and every message we receive.
          </p>
        </div>
      </main>

      <footer className="bg-green-900 text-green-300 py-8 px-5 mt-auto">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <div className="flex items-center gap-2">
            <Logo size="sm" />
            <span className="font-serif font-semibold text-amber-200">GolfBoard Scores</span>
          </div>
          <div className="flex gap-5 text-xs">
            <Link to="/" className="hover:text-amber-200">Home</Link>
            <Link to="/terms" className="hover:text-amber-200">Terms</Link>
            <Link to="/privacy" className="hover:text-amber-200">Privacy</Link>
          </div>
          <p className="text-green-500 text-xs">© {new Date().getFullYear()} GolfBoard Scores.</p>
        </div>
      </footer>
    </div>
  );
}